import { swalFireError } from "../../admin/sweet-alert.js";
import {
    isApplePayAvailable,
    onApplePaySdkSettled,
} from "../apple-pay-availability.js";

document.addEventListener("DOMContentLoaded", () => {
    const {
        merchantName,
        pageID,
        pageName,
        merchantID,
        domainName,
        blinkCurrencyList,
    } = window.config;
    //++++++++++++++++++++++Apple Pay integration+++++++++++++++++++++//

    const $applePayBTN = $("#apple-pay-button");

    onApplePaySdkSettled(function () {
        if (isApplePayAvailable()) {
            return;
        }

        /**
         * Dropping the whole .btn-col lets the remaining wallet button take the full
         * width of .btn-wrap, so Google Pay spans the section on its own.
         *
         **/
        $applePayBTN.closest(".btn-col").remove();
        $applePayBTN.remove();

        if (typeof window.removeEmptyButtonContainers === "function") {
            window.removeEmptyButtonContainers();
        }

        if ($("#card_payment .btn-wrap").children().length === 0) {
            $("#card_payment .or").hide();
        }
    });

    if (typeof $applePayBTN !== null && $applePayBTN !== "undefined") {
        $applePayBTN.click(function () {
            // Only the SDK's load/error events remove the button — see onApplePaySdkSettled.
            if (!isApplePayAvailable()) {
                return;
            }

            let applepayJqForm = $("#form1");
            var amount = $("#rawAmount").val();
            var subTotalDescr = "BLINKY";
            var label =
                applepayJqForm.find("[name=transactionUnique]").val() != ""
                    ? applepayJqForm.find("[name=transactionUnique]").val()
                    : merchantName;
            const request = {
                countryCode: "GB",
                currencyCode:
                    blinkCurrencyList[
                        applepayJqForm.find("[name=currencyCode]").val()
                    ].text,
                merchantCapabilities: ["supports3DS"],
                supportedNetworks: ["visa", "masterCard", "amex", "discover"],
                lineItems: [
                    {
                        label: subTotalDescr,
                        amount: amount,
                        newTotal: amount,
                    },
                ],
                total: {
                    label: label,
                    type: "final",
                    amount: amount,
                },
                requiredBillingContactFields: ["postalAddress"],
            };

            const session = new ApplePaySession(3, request);

            try {
                session.onvalidatemerchant = (event) => {
                    const promise = validateMerchant(event.validationURL);
                    promise
                        .then(function (merchantSession) {
                            session.completeMerchantValidation(merchantSession);
                        })
                        .catch((error) =>
                            console.error(
                                "OnCompleteMerchantValidation: " + error,
                            ),
                        );
                };
            } catch (error) {
                swalFireError("Something went wrong!");
            }

            function validateMerchant(valURL) {
                return new Promise(function (resolve, reject) {
                    $.ajaxSetup({
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content",
                            ),
                        },
                    });
                    $.ajax({
                        dataType: "json",
                        type: "POST",
                        data: {
                            process: "applepay.validateMerchant",
                            displayName: pageName,
                            merchantID: merchantID,
                            domainName: domainName,
                            validationURL: valURL,
                            amount: amount,
                            pageID: pageID,
                        },
                        url:
                            window.location.origin +
                            "/create/applepay/merchant/session",
                        success: function (data) {
                            if (data.status == 400) {
                                swalFireError("Something went wrong!");
                            } else {
                                resolve(data);
                            }
                        },
                    });
                });
            }

            try {
                session.onpaymentauthorized = async function (event) {
                    const result = {
                        status: ApplePaySession.STATUS_SUCCESS,
                    };
                    await applePayProcessPayment(event.payment);
                    session.completePayment(result);
                };
            } catch (error) {
                swalFireError("Something went wrong!");
            }
            /**
             * Started last, so every handler is attached before Apple opens the
             * payment sheet — on non-Apple browsers that sheet is the QR code, and
             * merchant validation fires as soon as it is shown.
             *
             **/
            session.begin();
        });
    }

    function applePayProcessPayment(paymentObj) {
        var paymentToken = paymentObj.token;
        let applepayJqForm = $("#form1");
        let $modalPaymentProccessing = $("#payment-processing-modal");
        let hiddenInputs = [];

        $("#payment-processing-modal").find("form").remove();
        const csrf = document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content");
        hiddenInputs.push(
            '<input type="hidden" name="_token" value="' + csrf + '">',
        );
        hiddenInputs.push(
            '<input type="hidden" name="paymentMethod" value="applepay">',
        );
        hiddenInputs.push('<input type="hidden" name="paymentToken" value="">');
        applepayJqForm.find(":input").each(function () {
            let $self = $(this);

            if ("" != $self.prop("name")) {
                if (
                    $self.prop("name") == "customerAddress" &&
                    $self.val().length == 0
                ) {
                    var addressLines =
                        paymentObj.billingContact.addressLines.join(",");
                    var addressDataArray = [
                        addressLines,
                        paymentObj?.billingContact?.administrativeArea,
                        paymentObj?.billingContact?.locality,
                        paymentObj?.billingContact?.countryCode,
                    ];
                    $self.val(addressDataArray.join(","));
                }

                if (
                    $self.prop("name") == "customerPostCode" &&
                    $self.val().length == 0 &&
                    paymentObj?.billingContact?.postalCode.trim().length > 0
                ) {
                    $self.val(paymentObj.billingContact.postalCode);
                }

                if (
                    $self.prop("name") == "nameon_card" &&
                    $self.val().length == 0 &&
                    paymentObj?.billingContact?.givenName.trim().length > 0
                ) {
                    $self.val(paymentObj.billingContact.givenName);
                }

                if (
                    $self.prop("name") == "customerName" &&
                    $self.val().length == 0 &&
                    paymentObj?.billingContact?.givenName.trim().length > 0
                ) {
                    $self.val(paymentObj.billingContact.givenName);
                }

                hiddenInputs.push(
                    '<input type="hidden" name="' +
                        $self.prop("name") +
                        '" value="' +
                        $self.val() +
                        '">',
                );
            }
        });

        $modalPaymentProccessing
            .find(".modal-body")
            .append(
                '<form action="' +
                    applepayJqForm.prop("action") +
                    '" method="' +
                    applepayJqForm.prop("method") +
                    '">' +
                    hiddenInputs.join("\r\n") +
                    "</form>",
            );
        let paymentDataRequest = JSON.stringify(paymentToken.paymentData);
        $modalPaymentProccessing.find("input[name=paymentToken]")[0].value =
            paymentDataRequest;

        $modalPaymentProccessing.modal("show");
        setTimeout(function () {
            $modalPaymentProccessing.find("form").submit();
        }, 1000);
        /**/
    }
    //++++++++++++++++++++++Apple Pay integration+++++++++++++++++++++//
});
